import _ from 'lodash'
import {
  maximum
} from '../Variables/Variables'

export function get_range(start, end) {
  return Array(end - start + 1).fill().map((_, id) => start + id)
}

export function get_maximum() {
  let total = 0
  Object.values(maximum).forEach(item => {
    total += item
  })
  return total
}

export function get_password(object) {
  let string = ''
  let numbers = '0123456789'
  let symbols = '@#%^*+=-_.,:;()[]'
  let lowercase = 'abcdefghijklmnopqrstuvwxyz'
  let uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  for (let i = 0 ; i < object.l ; i++) {
    string += lowercase.charAt(Math.floor(Math.random() * lowercase.length))
  }
  for (let i = 0 ; i < object.u ; i++) {
    string += uppercase.charAt(Math.floor(Math.random() * uppercase.length))
  }
  for (let i = 0 ; i < object.n ; i++) {
    string += numbers.charAt(Math.floor(Math.random() * numbers.length))
  }
  for (let i = 0 ; i < object.s ; i++) {
    string += symbols.charAt(Math.floor(Math.random() * symbols.length))
  }
  return _.shuffle(string).join('')
}
